import React, { useEffect, useState } from 'react';
import styles from "./ModalSaveChanges.module.css";

import {
  Modal as AntModal,
  ModalProps as AntModalProps,
  Row,
  Col,
} from 'antd';
import CustomLabel from '../Label/CustomLabel';
import CustomButton from '../Button/Button';
import CustomText from '../CustomText/CustomText';
import CustomSignature from '../CustomSignature/CustomSignature';
import CustomTextArea from '../CustomTextArea/CustomTextArea';

interface ModalProps extends AntModalProps {
  title: string;
  footerLeft?: React.ReactNode;
  onSave?: () => void;
  onClose: () => void;
  labelSubmit?: string;
  isLoading?: boolean;
  isLoadingSave?: boolean;
  handledDataFirma?: (data: string) => void;
  textOne?: string;
  textTwo?: string;
  textThree?: string;
  haveFirma?: boolean;
  formik?: any;
}


const ModalSaveChanges: React.FC<ModalProps> = ({
  handledDataFirma,
  title,
  children,
  footerLeft,
  onClose,
  onSave,
  labelSubmit,
  isLoading = false,
  isLoadingSave = false,
  textOne = '',
  textTwo = '',
  textThree = '',
  haveFirma = false,
  formik,
  ...props
}) => {

  const [isShowFirma, setIsShowFirma] = useState(false)
  const [isFirma, setIsFirma] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false);


  const changesetIsFirma = (data: any, opc: boolean) => {
    if (handledDataFirma) {
      handledDataFirma(data);
    }
    setIsFirma(true)
    setIsShowFirma(false)

  }
  const handleEventCheck = (opc: boolean) => {
    setIsShowFirma(opc)
    setIsFirma(false)


  }
  useEffect(() => {
    setIsDisabled(false)
  }, [])
  const handleClick = async () => {
    if (!onSave || isDisabled) return;

    setIsDisabled(true);

    try {
      await onSave();
      setIsDisabled(false);
    } catch (error) {
      setIsDisabled(false);
    }
  };
  return (
    <AntModal
      {...props}
      className={styles.Modal}
      loading={isLoading}
      onCancel={onClose}
      closeIcon={
        <span className="custom-close-icon" >
          x
        </span>
      }
      footer=""
    >
      <div className={styles.Container}>
        <img src='/ModalValidator.svg' className={styles.Container__Img} />
        <CustomLabel align="center" text={title ? title : 'title'} />
        {
          textOne && <CustomText customClass={styles.Containe__CustomText} text={textOne} />
        }
        {
          textTwo && <CustomText customClass={styles.Containe__CustomText} text={textTwo} />
        }
        {
          textThree && <strong><CustomText customClass={styles.Containe__CustomText} text={textThree} /></strong>
        }
        {
          haveFirma && (
            <div className={styles.Container__Checkbox}>
              <input type='checkbox' id='firma' onChange={() => handleEventCheck(!isShowFirma)} checked={isShowFirma} />
              <label className={styles.Container__Label} htmlFor='firma'><CustomText text={isFirma ? "Cambiar firmar " : "Firmar solicitud"} /></label>
            </div>
          )
        }
        {
          formik && (
            <Row gutter={[16, 16]}>
              <Col xs={24}>
                <CustomTextArea
                  label="Observaciones"
                  name="observations"
                  placeholder="Observaciones"
                  value={formik.values.observations}
                  error={formik.errors.observations}
                  touched={formik.touched.observations}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Col>
            </Row>
          )
        }
        {
          isShowFirma ? (
            <div className={styles.Container__Firma}>
              <CustomSignature changesetIsFirma={changesetIsFirma} isFirma={isShowFirma} />
            </div>
          ) : ''
        }
        {
          isFirma ? (
            <div className={styles.Container__HayFirma}>
              <img src='/FirmaAgregada.svg' /> <CustomText text='Firma agregada' />
            </div>
          ) : ''
        }

        {
          !isShowFirma ? (
            <div className={styles.Container__Btns}>
              <CustomButton
                buttonType={'secondary'}
                label={'No'}
                onClick={onClose}
                size="middle"
              />
              <CustomButton
                label={'Si'}
                loading={isDisabled}
                onClick={handleClick}
                size="middle"
                disabled={isDisabled}
              />

            </div>
          ) : ''
        }

      </div>
    </AntModal >
  )
}

export default ModalSaveChanges